var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32812 9.91602H13.4115",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.25H9.33333",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 19.25H16.9167",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6615 14.0357V18.7957C25.6615 22.8907 24.6231 23.9173 20.4815 23.9173H7.50813C3.36646 23.9173 2.32812 22.8907 2.32812 18.7957V9.20565C2.32812 5.11065 3.36646 4.08398 7.50813 4.08398H16.9115",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2538 4.81853L17.9255 9.14686C17.7621 9.31019 17.5988 9.63686 17.5638 9.87019L17.3305 11.5269C17.2488 12.1219 17.6688 12.5419 18.2638 12.4602L19.9205 12.2269C20.1538 12.1919 20.4805 12.0285 20.6438 11.8652L24.9721 7.53686C25.7188 6.79019 26.0688 5.92686 24.9721 4.83019C23.8638 3.72186 23.0005 4.07186 22.2538 4.81853Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6406 5.43652C22.014 6.75486 23.0406 7.78152 24.3473 8.14319",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardEditIcon);
export default __webpack_public_path__ + "static/media/card-edit-icon.14793862e7e32a6b20cfd6afb95da572.svg";
export { ForwardRef as ReactComponent };